import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { Container } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import BasePageStyles from "../Styling/BasePageStyling";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import HeroImage from "../../../assets/headers/caseStudyHeroImage.jpg";

function TabPanel(props) {
    const { className, children, value, index, ...other } = props;

    return (
        <div
            class={className}
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
    className: PropTypes.any.isRequired
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`
    };
}

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        backgroundSize: "auto",
        backgroundRepeat: "no-repeat",
        backgroundImage: `url(${HeroImage})`
    },
    paper: {
        backgroundColor: theme.palette.background.paper
    },
    grid: {
        justifyContent: "flex-start"
    },
    bullet: {
        display: "inline-block",
        margin: "0 2px",
        transform: "scale(0.8)"
    },
    title: {
        fontSize: 14
    },
    pos: {
        marginBottom: 12
    },
    downloadButtonContainer: {
        height: "55px"
    },
    cardStyle: {
        height: "auto",
        width: "100%"
    },
    downloadButton: {
        marginTop: "1rem"
    }
}));

export default function SimpleTabs() {
    const classes = useStyles();
    const classes2 = BasePageStyles();
    const [value, setValue] = React.useState(0);

    const handleChange = (_event, newValue) => {
        setValue(newValue);
    };

    return (
        <div
            className={classes.root}
            style={{
                paddingTop: "150px",
                paddingBottom: "40px",
                height: "500px"
            }}
        >
            <Container>
                <AppBar position="static">
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="simple tabs example"
                        centered
                    >
                        <Tab label="Frac" {...a11yProps(0)} />
                        <Tab label="Interwell" {...a11yProps(1)} />
                        <Tab label="Inflow" {...a11yProps(2)} />
                    </Tabs>
                </AppBar>
                <TabPanel className={classes.paper} value={value} index={0}>
                    <Typography
                        variant="body1"
                        color="textPrimary"
                        component="p"
                        style={{ margin: "2rem" }}
                    ></Typography>
                    <Grid container className={classes.grid} spacing={1}>
                        <Grid
                            container
                            direction="column"
                            alignItems="center"
                            justify="center"
                        >
                            <Card
                                className={classes.cardStyle}
                                style={{ boxShadow: "none" }}
                            >
                                <CardContent>
                                    <Typography
                                        variant="h4"
                                        className={classes2.demoH4}
                                        style={{ textAlign: "center" }}
                                    >
                                        Hydraulic fracture diagnostics
                                    </Typography>
                                    <br />
                                    <Typography
                                        variant="body1"
                                        color="textSecondary"
                                        component="p"
                                    >
                                        Our chemical tracer technology
                                        identifies the contribution of oil, gas
                                        and water from each stage. With no well
                                        intervention needed, a Tracer Production
                                        Log&trade; provides you with stage flow
                                        insights that can be linked to drilling
                                        and exploration, completion, stimulation
                                        and production parameters to optimise
                                        future field development plans.
                                        <br />
                                        <br />
                                    </Typography>
                                </CardContent>
                                <CardActions
                                    style={{ justifyContent: "center" }}
                                >
                                    <Button
                                        size="small"
                                        href="https://www.tracerco.com/services/drilling-and-production/hydraulic-fracture-diagnostics/"
                                    >
                                        <Typography color="primary">
                                            <u>Learn More</u>
                                        </Typography>
                                    </Button>
                                </CardActions>
                            </Card>
                        </Grid>
                    </Grid>
                    <Container
                        style={{ textAlign: "center" }}
                        className={classes.downloadButtonContainer}
                    >
                        <Button
                            onClick={() =>
                                window.open(
                                    require("../../../assets/caseStudies/AdvancedReservoirCharacterisation.pdf"),
                                    "_none"
                                )
                            }
                            className={classes.downloadButton}
                            variant="contained"
                            color="primary"
                            endIcon={
                                <PictureAsPdfIcon>Download</PictureAsPdfIcon>
                            }
                        >
                            View Case study
                        </Button>
                    </Container>
                </TabPanel>
                <TabPanel className={classes.paper} value={value} index={1}>
                    <Typography
                        variant="body1"
                        color="textPrimary"
                        component="p"
                        style={{ margin: "2rem" }}
                    ></Typography>
                    <Grid container className={classes.grid} spacing={1}>
                        <Grid
                            container
                            direction="column"
                            alignItems="center"
                            justify="center"
                        >
                            <Card
                                className={classes.cardStyle}
                                style={{ boxShadow: "none" }}
                            >
                                <CardContent>
                                    <Typography
                                        variant="h4"
                                        className={classes2.demoH4}
                                        style={{ textAlign: "center" }}
                                    >
                                        Interwell studies - Reservoir interwell
                                        connectivity
                                    </Typography>
                                    <br />
                                    <Typography
                                        variant="body1"
                                        color="textSecondary"
                                        component="p"
                                    >
                                        A Tracerco&trade; Interwell Study
                                        provides you with insights about
                                        waterflood, steam, gas or CO2 flow
                                        between wells. It can provide sweep
                                        efficiency information, display flow
                                        trends, and indicate the presence of
                                        high permeability channels. It can also
                                        function to identify if there is any
                                        active cross flow present between
                                        adjacent or vertical zones.
                                        <br />
                                        <br />
                                    </Typography>
                                </CardContent>
                                <CardActions
                                    style={{ justifyContent: "center" }}
                                >
                                    <Button
                                        size="small"
                                        href="https://www.tracerco.com/services/drilling-and-production/reservoir-interwell-connectivity/"
                                    >
                                        <Typography color="primary">
                                            <u>Learn More</u>
                                        </Typography>
                                    </Button>
                                </CardActions>
                            </Card>
                        </Grid>
                    </Grid>
                    <Container
                        style={{ textAlign: "center" }}
                        className={classes.downloadButtonContainer}
                    >
                        <Button
                            onClick={() =>
                                window.open(
                                    require("../../../assets/caseStudies/MonitorParent-childWellCommunication-LR.pdf"),
                                    "_none"
                                )
                            }
                            className={classes.downloadButton}
                            variant="contained"
                            color="primary"
                            endIcon={
                                <PictureAsPdfIcon>Download</PictureAsPdfIcon>
                            }
                        >
                            View Case study
                        </Button>
                    </Container>
                </TabPanel>
                <TabPanel className={classes.paper} value={value} index={2}>
                    <Typography
                        variant="body1"
                        color="textPrimary"
                        component="p"
                        style={{ margin: "2rem" }}
                    ></Typography>
                    <Grid container className={classes.grid} spacing={1}>
                        <Grid
                            container
                            direction="column"
                            alignItems="center"
                            justify="center"
                        >
                            <Card
                                className={classes.cardStyle}
                                style={{ boxShadow: "none" }}
                            >
                                <CardContent>
                                    <Typography
                                        variant="h4"
                                        className={classes2.demoH4}
                                        style={{ textAlign: "center" }}
                                    >
                                        Inflow measurement
                                    </Typography>
                                    <br />
                                    <Typography
                                        variant="body1"
                                        color="textSecondary"
                                        component="p"
                                    >
                                        Tracerco’s inflow measurement solution
                                        provides a continuous picture of your
                                        well’s performance. It collects data on
                                        zone-specific production, clean-out
                                        effectiveness, water breakthrough and
                                        plug, packer or sleeve open or closed
                                        status.
                                        <br />
                                        <br />
                                    </Typography>
                                </CardContent>
                                <CardActions
                                    style={{ justifyContent: "center" }}
                                >
                                    <Button
                                        size="small"
                                        href="https://www.tracerco.com/services/drilling-and-production/inflow-measurement/"
                                    >
                                        <Typography color="primary">
                                            <u>Learn More</u>
                                        </Typography>
                                    </Button>
                                </CardActions>
                            </Card>
                        </Grid>
                    </Grid>
                    <Container
                        style={{ textAlign: "center" }}
                        className={classes.downloadButtonContainer}
                    >
                        <Button
                            onClick={() =>
                                window.open(
                                    require("../../../assets/caseStudies/MeasuringOilandWaterInflow.pdf"),
                                    "_none"
                                )
                            }
                            className={classes.downloadButton}
                            variant="contained"
                            color="primary"
                            endIcon={
                                <PictureAsPdfIcon>Download</PictureAsPdfIcon>
                            }
                        >
                            View Case study
                        </Button>
                    </Container>
                </TabPanel>
            </Container>
        </div>
    );
}
